import React from "react";
import { H3 } from "theme/components/atoms/Typography/Heading";
import Sku from "theme/components/atoms/Typography/Sku";

const ProductName = ({ name, sku }) => {
  const nameLines = name.split(/ - (.+)/);
  return (
    <div className="product__name">
      <Sku sku={sku} />
      <H3 as="h1">
        {nameLines && nameLines.length > 0 ? (
          <>
            {nameLines[0]}
            {nameLines.length > 1 ? (
              <span className="product__name__subtitle">
                {nameLines[1].trim()}
              </span>
            ) : (
              ""
            )}
          </>
        ) : (
          name
        )}
      </H3>
      <meta itemProp="name" content={name} />
    </div>
  );
};

export default ProductName;
